import { render, staticRenderFns } from "./InputConfirmPassword.vue?vue&type=template&id=5bb0bfb8&scoped=true"
import script from "./InputConfirmPassword.vue?vue&type=script&lang=js"
export * from "./InputConfirmPassword.vue?vue&type=script&lang=js"
import style0 from "./InputConfirmPassword.vue?vue&type=style&index=0&id=5bb0bfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0bfb8",
  null
  
)

export default component.exports